export default {
  form: {
    preparation_time: {
      label: 'Introduceți timp personalizat (minute):',
      placeholder: 'Introduceți minute',
    },
  },
  buttons: {
    custom: 'Personalizat',
  },
  feedback: {
    preparation_time_required: 'Timpul de preparare trebuie să fie mai mare de 0 minute',
    min_preparation_time: 'Minimum {{minutes}} minute timp de preparare pentru livrare externă',
    max_preparation_time: 'Maximum {{minutes}} minute timp de preparare',
  },
};
